import { ReactNode, useEffect, useState } from 'react'
import { useTranslation } from 'react-i18next'

import benefitPlanPeriods, { PlanPeriodDto } from 'core/application/adminDashboard/benefitDetails/benefitPlanPeriods'

import { Alert, Collapse, CollapseItem, Empty, Icon } from 'common/components'
import { isBefore, nowV2 } from 'common/dateFormatters'
import { useQueryRequestV2 } from 'common/hooks'

import ReportCardButton from './ReportCardButton'

import './styles.less'

type ReportCardProps = {
  title: 'W-2 amounts' | 'PCORI Reports' | '1095-C Reports'
  description: ReactNode
  alerts: ReactNode[]
}

const ReportCardV2 = ({ title, description, alerts }: ReportCardProps) => {
  const { t: translate } = useTranslation()
  const { data: allPlanPeriods } = useQueryRequestV2({
    queryFn: () => benefitPlanPeriods(),
    initialState: [],
  })

  const now = nowV2()

  const [reports, setReports] = useState<PlanPeriodDto[]>([])

  useEffect(() => {
    if (allPlanPeriods.length === 0) return
    setReports(allPlanPeriods.filter((period) => isBefore(period.startDate, now)))
  }, [allPlanPeriods])

  return (
    <>
      {reports.length !== 0 ? (
        <div className="mb-16">
          <Collapse borderless defaultActiveKey={1}>
            <CollapseItem
              className="ReportCard-collapse"
              header={`${title} are ready to download`}
              key={1}
              content={
                <div>
                  <div className="color-gray-8 mt-4 mb-16">{description}</div>
                  {alerts}
                </div>
              }
            />
          </Collapse>
        </div>
      ) : (
        <div className="mb-16">
          <Empty
            description={
              <>
                <h6 className="semi-bold">No {title} to download</h6>
                <p className="color-gray-7">There are no {title} to download</p>
              </>
            }
          />
        </div>
      )}

      <div>
        {reports.map((period) => (
          <ReportCardButton period={period} title={title} />
        ))}
      </div>
    </>
  )
}

export default ReportCardV2
